module.exports = "/complete_verification-bf41fbd67985eacab1acbab8c5e524bf.svg";